import "./Header.scss";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// `onDark` renders light-coloured text/logo for use over the dark hero.
export default function Header({ onDark = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className={`header${onDark ? " header--on-dark" : ""}`}>
      <div className="header__inner">
        <Link to="/" className="header__brand" aria-label="ClassiFind home">
          <span className="header__title">
            Classi<em className="header__title-find">Find</em>
          </span>
        </Link>

        <nav className="header__nav" aria-label="Primary">
          <NavLink to="/" end className="header__link">
            home
          </NavLink>
          <NavLink to="/quiz" className="header__link">
            search
          </NavLink>
          <NavLink to="/finds" className="header__link">
            my finds
          </NavLink>

          {user ? (
            <>
              <span className="header__greeting">Hi, {user.name}</span>
              <button
                type="button"
                className="header__link header__link--button"
                onClick={handleLogout}
              >
                log out
              </button>
            </>
          ) : (
            <NavLink to="/login" className="header__link header__link--cta">
              log in
            </NavLink>
          )}
        </nav>
      </div>
    </header>
  );
}
